
import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
  isSearching: boolean;
  disabled?: boolean;
}

const SearchInput = ({ 
  value, 
  onChange, 
  onSearch, 
  isSearching,
  disabled 
}: SearchInputProps) => {
  return (
    <div className="relative flex-grow">
      <Input
        type="text"
        placeholder="Search for a location or enter coordinates"
        value={value}
        onChange={onChange}
        onKeyDown={(e) => e.key === "Enter" && onSearch()}
        className={`pr-10 ${isSearching ? 'bg-gray-100' : ''}`}
        disabled={disabled || isSearching}
        aria-label="Location search"
      />
      <button
        onClick={onSearch}
        className={`absolute right-2 top-1/2 transform -translate-y-1/2 ${
          isSearching ? 'text-blue-500' : 'text-gray-400 hover:text-gray-600'
        }`}
        disabled={disabled || isSearching}
        aria-label={isSearching ? "Searching..." : "Search"}
      >
        {isSearching ? (
          <div className="h-4 w-4 border-2 border-t-transparent border-blue-500 rounded-full animate-spin" />
        ) : (
          <Search className="h-4 w-4" />
        )}
      </button>
    </div>
  );
};

export default SearchInput;
